/** @format */

import { useState, useEffect } from 'react'
import { request } from 'src/utils'
import { useBoolean } from 'react-use'

interface OptionProps {
  params?: any
  manual?: boolean
  method?: 'GET' | 'POST'
  page?: boolean
  defaultPageSize?: 10 | 20 | 50 | 100
}

export type PageStateProps = {
  PageIndex?: number
  PageSize?: number
  pageIndex?: number
  pageSize?: number
}

const useFormTable = (
  api: string,
  { params = {}, manual = false, method = 'GET', page, defaultPageSize = 20 }: OptionProps,
  handleResult?: (data: any) => { tableData: any; totalCount?: number },
  handleParams?: (params: any) => any
) => {
  const [result, setResult] = useState<any>()
  const [total, setTotal] = useState<number>()
  const [loading, setLoading] = useBoolean(false)
  const [pageState, setPageState] = useState<PageStateProps>(
    page
      ? {}
      : api === '' || api?.includes('?Action=')
      ? {
          PageIndex: 1,
          PageSize: defaultPageSize
        }
      : {
          pageIndex: 1,
          pageSize: defaultPageSize
        }
  )

  useEffect(() => {
    if (!manual) {
      getTableData()
    }

    return () => {
      // console.log('return')
    }
  }, [])

  const getTableData = async (data = {}) => {
    if (!api) return
    const paramsObj = {
      ...pageState,
      ...params,
      ...data
    }
    setLoading(true)
    setPageState(
      api?.includes('?Action=')
        ? {
            PageIndex: paramsObj.PageIndex,
            PageSize: paramsObj.PageSize
          }
        : {
            pageIndex: paramsObj.pageIndex,
            pageSize: paramsObj.pageSize
          }
    )
    const res: any = await request(api, {
      method: method,
      data: handleParams ? handleParams(paramsObj) : paramsObj
    })
    const { tableData, totalCount } = handleResult && handleResult(res?.data)
    setLoading(false)
    setTotal(totalCount)
    setResult(tableData || [])
    if (!tableData || tableData?.length === 0 || !totalCount) {
      setPageState(
        api?.includes('?Action=')
          ? {
              PageIndex: 1,
              PageSize: defaultPageSize
            }
          : {
              pageIndex: 1,
              pageSize: defaultPageSize
            }
      )
    }
  }

  return {
    run: getTableData,
    resetPage: () => {
      setPageState(
        page
          ? {}
          : api === '' || api?.includes('?Action=')
          ? {
              PageIndex: 1,
              PageSize: defaultPageSize
            }
          : {
              pageIndex: 1,
              pageSize: defaultPageSize
            }
      )
    },
    result,
    pageState,
    total,
    loading
  }
}

export default useFormTable
